import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      // Navigation
      nav: {
        home: 'Accueil',
        events: 'Événements',
        map: 'Carte',
        marketplace: 'Marketplace',
        profile: 'Profil',
        login: 'Connexion',
        register: "S'inscrire",
        logout: 'Déconnexion',
      },
      // Landing page
      landing: {
        hero: {
          title: 'La communauté des passionnés de moto',
          subtitle: 'Rejoignez des milliers de motards, découvrez des événements, trouvez des lieux biker-friendly et achetez/vendez du matériel.',
          cta: 'Rejoindre la communauté',
          ctaSecondary: 'Découvrir',
        },
        features: {
          title: 'Tout ce dont vous avez besoin',
          events: {
            title: 'Événements',
            description: 'Trouvez des rassemblements, balades et concentrations près de chez vous.',
          },
          places: {
            title: 'Lieux',
            description: 'Découvrez les cafés, restos et hôtels biker-friendly.',
          },
          marketplace: {
            title: 'Marketplace',
            description: "Achetez et vendez motos, pièces et accessoires.",
          },
          community: {
            title: 'Communauté',
            description: 'Connectez-vous avec des passionnés partout en Europe.',
          },
        },
      },
      // Auth
      auth: {
        login: {
          title: 'Connexion',
          email: 'Email',
          password: 'Mot de passe',
          submit: 'Se connecter',
          noAccount: "Pas encore de compte ?",
          register: "S'inscrire",
        },
        register: {
          title: 'Créer un compte',
          username: "Nom d'utilisateur",
          email: 'Email',
          password: 'Mot de passe',
          submit: "S'inscrire",
          hasAccount: 'Déjà un compte ?',
          login: 'Se connecter',
        },
      },
      // Events
      events: {
        title: 'Événements',
        filters: {
          all: 'Tous',
          concentration: 'Concentrations',
          ride: 'Balades',
          meeting: 'Rencontres',
          race: 'Courses',
        },
        create: 'Créer un événement',
        participants: 'participants',
        join: 'Participer',
        leave: 'Se désinscrire',
        noEvents: 'Aucun événement trouvé',
      },
      // Map
      map: {
        title: 'Carte',
        filters: {
          all: 'Tous',
          cafe: 'Cafés',
          restaurant: 'Restaurants',
          hotel: 'Hôtels',
          garage: 'Garages',
        },
        addPlace: 'Ajouter un lieu',
      },
      // Marketplace
      marketplace: {
        title: 'Marketplace',
        categories: {
          all: 'Tout',
          motorcycle: 'Motos',
          parts: 'Pièces',
          accessories: 'Accessoires',
          gear: 'Équipement',
        },
        conditions: {
          new: 'Neuf',
          like_new: 'Comme neuf',
          good: 'Bon état',
          fair: 'État correct',
        },
        createListing: 'Vendre',
        contact: 'Contacter le vendeur',
        views: 'vues',
        noListings: 'Aucune annonce trouvée',
      },
      // Profile
      profile: {
        title: 'Mon Profil',
        myGarage: 'Mon Garage',
        addMotorcycle: 'Ajouter une moto',
        myListings: 'Mes annonces',
        edit: 'Modifier',
        save: 'Enregistrer',
        bio: 'Bio',
        location: 'Localisation',
        country: 'Pays',
      },
      // Social/Posts
      social: {
        feed: 'Fil',
        posts: 'Posts',
        newPost: 'Nouveau post',
        shareRide: 'Partager votre balade',
        whatsOnYourMind: 'Quoi de neuf ?',
        km: 'km parcourus',
        like: 'Aimer',
        comment: 'Commenter',
        comments: 'commentaires',
        share: 'Partager',
        follow: 'Suivre',
        unfollow: 'Ne plus suivre',
        followers: 'Abonnés',
        following: 'Abonnements',
        noPosts: 'Aucun post pour le moment',
      },
      // Payments
      payment: {
        buyNow: 'Acheter maintenant',
        securePayment: 'Paiement sécurisé',
        commission: 'Commission plateforme',
        total: 'Total',
        processing: 'Traitement...',
        success: 'Paiement réussi !',
        cancelled: 'Paiement annulé',
        sold: 'Vendu',
        purchases: 'Mes achats',
        sales: 'Mes ventes',
      },
      // Common
      common: {
        search: 'Rechercher...',
        loading: 'Chargement...',
        error: 'Une erreur est survenue',
        success: 'Succès',
        cancel: 'Annuler',
        save: 'Enregistrer',
        delete: 'Supprimer',
        edit: 'Modifier',
        close: 'Fermer',
        viewAll: 'Voir tout',
        seeMore: 'Voir plus',
        upload: 'Télécharger',
      },
      // Countries
      countries: {
        FR: 'France',
        DE: 'Allemagne',
        ES: 'Espagne',
        IT: 'Italie',
        BE: 'Belgique',
        CH: 'Suisse',
        NL: 'Pays-Bas',
        PT: 'Portugal',
        UK: 'Royaume-Uni',
      },
    },
  },
  en: {
    translation: {
      // Navigation
      nav: {
        home: 'Home',
        events: 'Events',
        map: 'Map',
        marketplace: 'Marketplace',
        profile: 'Profile',
        login: 'Login',
        register: 'Sign up',
        logout: 'Logout',
      },
      // Landing page
      landing: {
        hero: {
          title: 'The motorcycle enthusiast community',
          subtitle: 'Join thousands of bikers, discover events, find biker-friendly places and buy/sell gear.',
          cta: 'Join the community',
          ctaSecondary: 'Discover',
        },
        features: {
          title: 'Everything you need',
          events: {
            title: 'Events',
            description: 'Find gatherings, rides and rallies near you.',
          },
          places: {
            title: 'Places',
            description: 'Discover biker-friendly cafes, restaurants and hotels.',
          },
          marketplace: {
            title: 'Marketplace',
            description: 'Buy and sell motorcycles, parts and accessories.',
          },
          community: {
            title: 'Community',
            description: 'Connect with enthusiasts across Europe.',
          },
        },
      },
      // Auth
      auth: {
        login: {
          title: 'Login',
          email: 'Email',
          password: 'Password',
          submit: 'Sign in',
          noAccount: "Don't have an account?",
          register: 'Sign up',
        },
        register: {
          title: 'Create an account',
          username: 'Username',
          email: 'Email',
          password: 'Password',
          submit: 'Sign up',
          hasAccount: 'Already have an account?',
          login: 'Sign in',
        },
      },
      // Events
      events: {
        title: 'Events',
        filters: {
          all: 'All',
          concentration: 'Rallies',
          ride: 'Rides',
          meeting: 'Meetups',
          race: 'Races',
        },
        create: 'Create event',
        participants: 'participants',
        join: 'Join',
        leave: 'Leave',
        noEvents: 'No events found',
      },
      // Map
      map: {
        title: 'Map',
        filters: {
          all: 'All',
          cafe: 'Cafes',
          restaurant: 'Restaurants',
          hotel: 'Hotels',
          garage: 'Garages',
        },
        addPlace: 'Add a place',
      },
      // Marketplace
      marketplace: {
        title: 'Marketplace',
        categories: {
          all: 'All',
          motorcycle: 'Motorcycles',
          parts: 'Parts',
          accessories: 'Accessories',
          gear: 'Gear',
        },
        conditions: {
          new: 'New',
          like_new: 'Like new',
          good: 'Good',
          fair: 'Fair',
        },
        createListing: 'Sell',
        contact: 'Contact seller',
        views: 'views',
        noListings: 'No listings found',
      },
      // Profile
      profile: {
        title: 'My Profile',
        myGarage: 'My Garage',
        addMotorcycle: 'Add motorcycle',
        myListings: 'My listings',
        edit: 'Edit',
        save: 'Save',
        bio: 'Bio',
        location: 'Location',
        country: 'Country',
      },
      // Social/Posts
      social: {
        feed: 'Feed',
        posts: 'Posts',
        newPost: 'New post',
        shareRide: 'Share your ride',
        whatsOnYourMind: "What's on your mind?",
        km: 'km ridden',
        like: 'Like',
        comment: 'Comment',
        comments: 'comments',
        share: 'Share',
        follow: 'Follow',
        unfollow: 'Unfollow',
        followers: 'Followers',
        following: 'Following',
        noPosts: 'No posts yet',
      },
      // Payments
      payment: {
        buyNow: 'Buy now',
        securePayment: 'Secure payment',
        commission: 'Platform fee',
        total: 'Total',
        processing: 'Processing...',
        success: 'Payment successful!',
        cancelled: 'Payment cancelled',
        sold: 'Sold',
        purchases: 'My purchases',
        sales: 'My sales',
      },
      // Common
      common: {
        search: 'Search...',
        loading: 'Loading...',
        error: 'An error occurred',
        success: 'Success',
        cancel: 'Cancel',
        save: 'Save',
        delete: 'Delete',
        edit: 'Edit',
        close: 'Close',
        viewAll: 'View all',
        seeMore: 'See more',
        upload: 'Upload',
      },
      // Countries
      countries: {
        FR: 'France',
        DE: 'Germany',
        ES: 'Spain',
        IT: 'Italy',
        BE: 'Belgium',
        CH: 'Switzerland',
        NL: 'Netherlands',
        PT: 'Portugal',
        UK: 'United Kingdom',
      },
    },
  },
};

const savedLanguage = localStorage.getItem('motosocial_language') || 'fr';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
